var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',_vm._b({attrs:{"label":_vm.$capitalize(_vm.$tc('model.products_budget_type')),"items":_vm.items,"value":_vm.value,"item-text":"description","item-value":"id","loading":_vm.loading},on:{"input":_vm.handleInput,"focus":_vm.getItems}},'v-select',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }